const th = {
  HEADER_TITLE: 'เลือกรูปแบบที่ต้องการ',
  INSERT_DETAILS_ON_IMAGE: 'ใส่ข้อมูลรายละเอียดบนรูป',
  IPHONE_REMARK_BROWSER: '*สำหรับ iPhone ใช้งานผ่านแอปพลิเคชัน Safari เท่านั้น',
  COPYRIGHT_WARNING: '*ขอความร่วมมือใช้รูปภาพของทางแต่ละร้านเพื่อหลีกเลี่ยงปัญหาลิขสิทธิ์',
  PLEASE_VALIDATE_MERCHANT_INCLUDE_PRO_DD: 'ลูกค้าโปรดตรวจสอบร้านค้าที่เข้าร่วมโปรดีดีโดยสังเกต',
  PRO_DD_DETAIL_ON_RBH_APP: 'จากแถบริ้วสีส้มเมื่อคุณสั่งอาหารในแอป Robinhood',
  MERCHANT_NAME: 'ชื่อร้านค้า',
  MERCHANT_LINE_2_NAME: 'ชื่อร้านค้า (บรรทัด2)',
  BRANCH_NAME_OPTIONAL: 'ชื่อสาขา (ถ้ามี)',
  BRANCH_NAME_LOCATION_OPTIONAL: 'ชื่อสาขา (หรือย่านร้านค้า)',
  INSERT_MERCHANT_NAME: 'ใส่ชื่อร้านค้า',
  UPLOAD_IMAGE_LABEL: 'อัพโหลดรูปภาพ',
  CHANGE_IMAGE_LABEL: 'เปลี่ยนรูปภาพ',
  ADD_LINE_LABEL: 'เพิ่มบรรทัด',
  REMOVE_LINE_LABEL: 'ลบบรรทัด',
  MERCHANT_CODE_FOR_QR_LABEL: 'รหัสร้านค้า เพื่อสร้าง QR code ร้านค้าของคุณ (ถ้ามี)',
  INSERT_MERCHANT_CODE_LABEL: 'ใส่รหัสร้านค้า',
  INSERT_INTRODUCE_LABEL: 'ใส่คำอธิบาย',
  INSERT_MERCHANT_NAME_LABEL: 'ใส่ชื่อร้านค้า',
  INSERT_BRANCH_NAME_LABEL: 'ใส่ชื่อสาขา',
  INSERT_BRANCH_OR_LOCATION_NAME_LABEL: 'ใส่ชื่อสาขา (หรือย่านร้านค้า)',
  INTRODUCE_MERCHANT_LABEL: 'คำอธิบายแนะนำร้านค้า',
  INTRODUCE_MERCHANT_LINE_2_LABEL: 'คำอธิบายแนะนำร้านค้า (บรรทัด2)',
  BACK_LABEL: 'ย้อนกลับ',
  SAVE_IMAGE_LABEL: 'บันทึกรูปภาพ',
  SAVE_IMAGE_ALREADY_LABEL: 'บันทึกแล้ว!',
  REMOVE_IMAGE_LABEL: 'ลบรูปภาพ',
  CONTINUE_EDIT_INFORMATION: 'แก้ไขข้อมูลต่อ',
  DATA_WILL_REMOVE: 'ข้อมูลทั้งหมดจะถูกลบ',
  BACK_TO_CHOOSE_TYPE: 'กลับหน้าเลือกรูปแบบ',
  INSTRUCTION_TO_GET_YOUR_MERCHANT_CODE: 'วิธีดูรหัสร้านค้าของคุณ',
  INSTRUCTION_1_OPEN_RBH_SHOP_APP: '1. เปิดแอป “Robinhood Shop”',
  INSTRUCTION_2_CLICK_MENU_ON_THE_TOP_RIGHT: '2. กดปุ่ม “เมนู” ที่มุมขวาบน',
  INSTRUCTION_3_GET_YOUR_MERCHANT_CODE: '3. รหัสร้านค้าจะแสดงใต้ชื่อร้านค้า',
  QUOTE_OF_IMAGE: 'ราคาเท่าหน้าร้าน ปริมาณอาหารไม่ลด',
  ORDER_NOW: 'สั่งเลย',
  MENU_NAME: 'ชื่อเมนู',
  INSERT_MENU_NAME: 'ใส่ชื่อเมนู',
  AMOUNT_COUNT: 'จำนวนซื้อ',
  INSERT_AMOUNT: 'ใส่จำนวนซื้อ',
  GET_FREE: 'แถม',
  FREE_AMOUNT: 'จำนวนแถม',
  INSERT_FREE_AMOUNT: 'จำนวนแถม',
  DISCOUNT_AMOUNT: 'จำนวนส่วนลด',
  NET_PRICE_OPTIONAL: 'ราคาขาย หักส่วนลดแล้ว (ใส่ก็ได้ไม่ใส่ก็ได้)',
  INSERT_NET_PRICE: 'ใส่ราคาหักส่วนลด',
  ALL_MENU: 'ทุกเมนู',
  DISCOUNT: 'ลด',
  INSERT_DISCOUNT_AMOUNT: 'ใส่ส่วนลด',
  UNIT: 'หน่วย',
  CURRENCY: '฿',
  PERCENT: '%',
  ROOM_TYPE_NAME: 'ชื่อห้องพัก',
  ROOM_TYPE_NAME_LINE_2: 'ชื่อห้องพัก (บรรทัด2)',
  INSERT_ROOM_TYPE_NAME_LABEL: 'ใส่ชื่อห้องพัก',
  LOGO_LEFT: 'รูปภาพด้านบนซ้าย',
  LOGO_RIGHT: 'รูปภาพด้านบนขวา',
  INSERT_LOGO_LEFT_LABEL: 'ใส่รูปภาพด้านบนซ้าย',
  INSERT_LOGO_RIGHT_LABEL: 'ใส่รูปภาพด้านบนขวา',
  LOCATION_NAME: 'ชื่อโรงแรม',
  INSERT_LOCATION_NAME_LABEL: 'ใส่ชื่อโรงแรม',
  PIN_COLOR: 'สีหมุด',
  SHADOW_COLOR: 'สีเงา',
};

export default th;
